import { Notification } from './reducer';

export enum NotificationActionType {
  SET_NOTIFICATION = `SET_NOTIFICATION`,
}

export interface SetNotificationAction {
  type: NotificationActionType.SET_NOTIFICATION;
  payload?: Notification;
}

export type NotificationActions = SetNotificationAction;
